var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductDescriptionItemOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25009 3.33355H13.7503V1.11133H15.1392V3.33355H17.2224C18.1429 3.33355 18.8891 4.07974 18.8891 5.00022V8.47244H1.11133V5.00022C1.11133 4.07974 1.85752 3.33355 2.77799 3.33355H4.86121V1.11133H6.25009V3.33355ZM2.77799 4.72244H17.2224C17.3759 4.72244 17.5002 4.84681 17.5002 5.00022V7.0835H2.50022V5.00022C2.50022 4.84681 2.62458 4.72244 2.77799 4.72244Z",
    fill: "#47423D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 10.1387H18.8891V17.222C18.8891 18.1425 18.1429 18.8887 17.2224 18.8887H2.77799C1.85752 18.8887 1.11133 18.1425 1.11133 17.222V10.1387H2.50022V17.222C2.50022 17.3755 2.62458 17.4998 2.77799 17.4998H17.2224C17.3759 17.4998 17.5002 17.3755 17.5002 17.222V10.1387Z",
    fill: "#47423D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44531 11.6667C4.44531 10.7462 5.1915 10 6.11198 10H7.22309C8.14357 10 8.88976 10.7462 8.88976 11.6667V12.7778C8.88976 13.6982 8.14357 14.4444 7.22309 14.4444H6.11198C5.1915 14.4444 4.44531 13.6982 4.44531 12.7778V11.6667ZM6.11198 11.3889H7.22309C7.3765 11.3889 7.50087 11.5132 7.50087 11.6667V12.7778C7.50087 12.9312 7.3765 13.0556 7.22309 13.0556H6.11198C5.95857 13.0556 5.8342 12.9312 5.8342 12.7778V11.6667C5.8342 11.5132 5.95857 11.3889 6.11198 11.3889Z",
    fill: "#47423D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptionItemOne);
export default __webpack_public_path__ + "static/media/product-description-item-one.0aef7d7d61b463151b90c35ed5cd51d3.svg";
export { ForwardRef as ReactComponent };